import React, { useState, useContext } from "react";
import { View, StyleSheet } from "react-native";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import colors from "../../config/colors";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import UserContext from "../../context/UserContext";
import Logger from "../../common/utils/Logger";

function NtNavigationPannel({ options }) {
  const context = useContext(UserContext);

  const renderMenu = (item) => {
    const defaultIconSize = 22;

    if (item?.items) {
      return (
        <SubMenu
          key={item.title}
          icon={
            <NtMaterialIcon
              name={item.icon}
              color={colors.almostBlack}
              size={item.iconSize || defaultIconSize}
            />
          }
          style={{
            ...styles.menu,
            ...item.titleStyle,
            backgroundColor: item.isSelected() ? colors.lighestGray : null,
          }}
          label={item.title}
        >
          {item?.items?.map((each) => renderMenu(each))}
        </SubMenu>
      );
    } else {
      return (
        <MenuItem
          key={item.title}
          icon={
            item.icon ? (
              <NtMaterialIcon
                name={item.icon}
                color={colors.almostBlack}
                size={item.iconSize || defaultIconSize}
              />
            ) : null
          }
          onClick={() => {
            item.action();
          }}
          style={{
            ...styles.menu,
            ...item.titleStyle,
            backgroundColor: item?.isSelected() ? "white" : null,
          }}
        >
          {item.title}
        </MenuItem>
      );
    }
  };

  return (
    <View style={styles.container}>
      <Sidebar
        backgroundColor={colors.lighestGray}
        style={{
          borderWidth: 0,
        }}
        collapsed={context.user?.ui?.sidebarcollapsed}
      >
        <View style={{ height: "100%" }}>
          <View style={{ alignItems: "flex-start", paddingLeft: 15 }}>
            <NtTouchableEffect
              style={{
                marginTop: 25,
                backgroundColor: "white",
                padding: 10,
                borderRadius: 30,
              }}
              onPress={() => {
                context.updateUser({
                  ...context.user,
                  ui: { sidebarcollapsed: !context.user?.ui?.sidebarcollapsed },
                });
              }}
            >
              <NtMaterialIcon
                name="menu"
                size={23}
                color={colors.almostBlack}
              />
            </NtTouchableEffect>
          </View>

          <Menu style={{ marginTop: 25 }} closeOnClick={true}>
            {options?.map((each) => renderMenu(each))}
          </Menu>

          <View style={{ flex: 1 }} />
        </View>
      </Sidebar>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
  menu: {
    fontFamily: "Helvetica",
    color: colors.almostBlack,
    fontWeight: "600",
    fontSize: 13,
  },
});

export default NtNavigationPannel;
